import { render, staticRenderFns } from "./DocumentTemplateDetailEdit.vue?vue&type=template&id=de42bf32&"
import script from "./DocumentTemplateDetailEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports